const STRINGS = {
	loggedInAs: gettext('You are currently logged in as:'),
	returnToAdmin: gettext('Return to admin'),
};

module.exports = { STRINGS };
